import { Box } from '@mui/material'
import React from 'react'

interface ResponsiveHeight {
  xs?: number
  sm?: number
  md?: number
  lg?: number
}

interface TwoColumnListProps {
  items: React.ReactNode[][]
  height: ResponsiveHeight
  columnGap?: number
}

export const TwoColumnList: React.FC<TwoColumnListProps> = ({
  items,
  height,
  columnGap = 2,
}) => {
  return (
    <>
      {/* Mobile: single column */}
      <Box
        sx={{
          display: { xs: 'flex', sm: 'none' },
          flexDirection: 'column',
          gap: columnGap,
          width: '100%',
        }}
      >
        {items.flat().map((item, itemIndex) => (
          <Box key={itemIndex}>{item}</Box>
        ))}
      </Box>

      {/* Desktop: grid layout */}
      <Box
        sx={{
          display: { md: 'grid' },
          gridTemplateColumns: `repeat(${items.length}, 1fr)`,
          gap: columnGap,
          width: '100%',
          height: {
            xs: height.xs ? `${height.xs}px` : 'auto',
            sm: height.sm
              ? `${height.sm}px`
              : height.xs
                ? `${height.xs}px`
                : 'auto',
            md: height.md
              ? `${height.md}px`
              : height.sm
                ? `${height.sm}px`
                : height.xs
                  ? `${height.xs}px`
                  : 'auto',
            lg: height.lg
              ? `${height.lg}px`
              : height.md
                ? `${height.md}px`
                : height.sm
                  ? `${height.sm}px`
                  : height.xs
                    ? `${height.xs}px`
                    : 'auto',
          },
        }}
      >
        {items.map((column, columnIndex) => (
          <Box
            key={columnIndex}
            sx={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {column.map((item, itemIndex) => (
              <Box key={itemIndex}>{item}</Box>
            ))}
          </Box>
        ))}
      </Box>
    </>
  )
}
